import application from 'application/application';

import template from './info.template.html';

import controller from './info.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.account.info', {
				url: '/informacoes',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Informações'
				}
			});

	}]);
